module.exports = __webpack_public_path__ + "assets/10bisPlusIcon-2628c1.svg";